<script lang="ts">
  import { ChevronLeft, ChevronRight } from '@lucide/svelte'
  import Button from '../button/Button.svelte'

  type Props = {
    currentPage: number
    totalPages: number
  }

  let { currentPage = $bindable(), totalPages }: Props = $props()
</script>

{#if totalPages > 1}
  <div class="pagination-container">
    <Button
      disabled={currentPage < 2}
      onclick={() => (currentPage -= 1)}
      variant="secondary"
    >
      <ChevronLeft />
    </Button>

    <div class="pages-container">
      {#each new Array(totalPages), i (i)}
        {@const pageNumber = i + 1}

        {#if pageNumber <= 1 || Math.abs(pageNumber - totalPages) <= 1 || Math.abs(pageNumber - currentPage) <= 1}
          <button
            class="pagination-button"
            class:current={pageNumber === currentPage}
            onclick={() => (currentPage = pageNumber)}
          >
            {pageNumber}
          </button>
        {:else if pageNumber === 2 && currentPage > 3}
          <button
            class="pagination-button"
            disabled
          >...</button>
        {:else if pageNumber === totalPages - 2 && Math.abs(totalPages - currentPage) > 1}
          <button
            class="pagination-button"
            disabled
          >...</button>
        {/if}
      {/each}
    </div>
    <Button
      disabled={currentPage >= totalPages}
      onclick={() => (currentPage += 1)}
      variant="secondary"
    >
      <ChevronRight />
    </Button>
  </div>
{/if}

<style lang="scss">
  .pagination-container {
    align-items: center;
    display: flex;
    gap: 1rem;
    justify-content: center;

    .pages-container {
      align-items: center;
      display: flex;
      gap: 0.75rem;
      justify-content: center;
    }

    .pagination-button {
      align-items: center;
      background: transparent;
      border-radius: 1rem;
      border: 0;
      display: flex;
      cursor: pointer;
      height: 1.5rem;
      justify-content: center;
      min-width: 1.5rem;
      transition: all .3s ease;

      &.current {
        background: var(--button-primary-gradient);

        &:hover {
          background: var(--button-primary-gradient);
        }
      }

      &:hover {
        background: var(--button-ghost-hover-background);
      }

      &:disabled {
        background: transparent;
        cursor: default;
      }
    }
  }
</style>
